import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatFabButton } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { HowdenAlertService, HowdenUserService, RolEvalHideDirective } from '@howdeniberia/core-front';
import { ShowEditCredentialService } from 'src/app/features/credentials/services/show-edit-credential.service';
import { ClavesCiasApiService } from './../../../../core/services/api/claves-cias-api.service';
import { CredentialsListComponent } from './../../components/credentials-list/credentials-list.component';
import { CredentialsMapper } from './../../mappers/credential-mapper';

@Component({
  selector: 'howden-credentials-page',
  templateUrl: './credentials-page.component.html',
  styleUrls: ['./credentials-page.component.scss'],
  imports: [
    MatFabButton,
    MatIcon,
    MatDialogModule,
    CredentialsListComponent,
    RolEvalHideDirective
  ]
})
export class CredentialsPageComponent implements OnInit {
  private usrSrv = inject(HowdenUserService);
  private alertSrv = inject(HowdenAlertService);
  private showEditSrv = inject(ShowEditCredentialService);
  private clavesCiasSrv = inject(ClavesCiasApiService);

  private mapper: CredentialsMapper = new CredentialsMapper();
  seeAdd = false;

  @ViewChild(CredentialsListComponent) list!: CredentialsListComponent;

  ngOnInit(): void {
    const r = this.usrSrv.role;
    this.seeAdd = r.roles.filter(x => x === 'HowdenClavesCiasAdmin').length > 0;
  }

  newCredential(): void {
    this.showEditSrv.open().subscribe(result => {
      if (result) {
        const newCredential = this.mapper.viewModelTonewCredentialDto(result);
        this.clavesCiasSrv.registerCredential(newCredential).subscribe({
          next: (data) => {
            this.list.insertOnDataraw(data);
            this.alertSrv.success('Creado', `número creado: ${data.credentialId}`);
          }
        });
      }
    });
  }

  reload(): void {
    this.list.reload();
  }
}
